import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Container,
  Grid,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Divider,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { Helmet } from "react-helmet";
import InputLabel from "@mui/material/InputLabel";
import PreInstalledApplications from "./PreInstalledApplications";
import HypervisedPreInstalledApplications from "./HypervisedPreInstalledApplications";
import CustomApplications from "./CustomApplications";
import VirtualizationCustomApplications from "./VirtualizationCustomApplications";
import SharedvmApplications from "./SharedvmApplications";
import WiseApplications from "./WiseApplications";
import ClearIcon from "@mui/icons-material/Clear";
import CalculateIcon from "@mui/icons-material/Calculate";
import PDF from "./pdf";
import PDF1 from "./pdf1";
import PDF2 from "./pdf2";
import EstimationSchedule from "./EstimationSchedule";
import ScheduleError from "./ScheduleError";
import ScheduleError_enddate from "./ScheduleError_enddate";
import ScheduleError_enddatetime from "./ScheduleError_enddatetime";
import HourError from "./HourError";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
// import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0)", // Semi-transparent white background
            backdropFilter: "blur(1px)", // Apply blur effect
            zIndex: 10, // Ensure loader is on top
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box sx={{ opacity: loading ? 0.5 : 1, transition: "opacity 0.3s" }}>
        {children}
      </Box>
    </Box>
  );
};


const useStyles = makeStyles((theme) => ({
  btncenter: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 30px",
    paddingLeft: 10,
  },
}));

export default function LabEstimation() {
  const classes = useStyles();

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const [instancetype, setInstancetype] = React.useState([[]]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [virtualizationtype, setVirtualizationtype] = React.useState([[]]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/virtualizedinstancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setVirtualizationtype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [svminstancetype, setSVMInstancetype] = React.useState([[]]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/svminstancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setSVMInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);



  const [templateapplication, setTemplateApplication] = React.useState([]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templaterequest/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setTemplateApplication(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [state, setState] = React.useState({
    reportname: "",
    labtype: "applications",
    nooftrainee: "",
    actualhours: "",
    application: "",
    machinetype: "linux",
    instance_type: "",
    ostype: "linux",
    instance_storage: "",
    customdata: "",
    start_date_time: "",
    end_date_time: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;

    const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '');

    setState((prevState) => ({
      ...prevState,
      [id]: filteredValue,
    }));

    if (id === 'labtype') {
      setFormFields([]);
    }
  };

  const [open, setOpen] = React.useState(false);

  const [checkstate, setCheckstate] = React.useState({
    selectedValue: "checkedA",
  });

  const [formFields, setFormFields] = React.useState([]);
  const [state1, setState1] = React.useState({
    ostype: "linux",
  });

  const [linuxsingleselectedapp, setLinuxsingleselectedapp] = React.useState(
    []
  );

  const [linuxmultiselectindex, setlinuxmultiselectindex] = React.useState([]);
  const [linuxselectedapps, setLinuxselectedapps] = React.useState([]);

  const [windowssingleselectedapp, setWindowssingleselectedapp] =
    React.useState([]);
  const [windowsmultiselectindex, setWindowsmultiselectindex] = React.useState(
    []
  );
  const [windowsselectedapps, setWindowsselectedapps] = React.useState([]);

  const [scheduleerroropen, setscheduleerroropen] = React.useState(false);
  const [scheduleerroropen1, setscheduleerroropen1] = React.useState(false);
  const [scheduleerroropen2, setscheduleerroropen2] = React.useState(false);

  const [validlabnameopen, setvalidlabnameopen] = React.useState(false);
  const [hourerroropen, sethourerroropen] = React.useState(false);

  const [programmingapps, setProgrammingapps] = React.useState([]);
  const [Systemtools, setSystemtools] = React.useState([]);
  const [normalapps, setNormalapps] = React.useState([]);
  const [devopsapps, setDevopsapps] = React.useState([]);

  const [devopsport, setDevopsport] = React.useState([]);
  const [normalport, setNormalport] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const [estimationcount, setEstimationcount] = React.useState({
    application: "",
    no_of_trainee: "",
    actual_hours: "",
    storage_hours: "",
    overall_app_price: "",
    overall_type_price: "",
    overall_storage_price: "",
    total_price: "",
    details: [],
  });
  // const handleSubmitClick = (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  // }

  const handleSubmitClick = (e) => {
    e.preventDefault();
    // console.log("ReportName", state.reportname)
    // console.log("typeOf", typeof (state.reportname))
    let timecount = 0;
    let timecount_enddate = 0;
    let timecount_enddatetime = 0;

    if (state.reportname.length <= 0) {
      setOpen(true)
    }
    else {

      if (checkstate.selectedValue === "checkedA") {
        state["depends_on"] = "always";
      } else if (checkstate.selectedValue === "checkedB") {
        state["depends_on"] = "during_training";
      } else {
        state["depends_on"] = "immediate";
      }

      const Lengthform = formFields.length;

      [...Array(Lengthform)].map((frm, i) => {
        if (normalapps[i]) {
          const listofnrmlapps = normalapps[i].map((b) => {
            return `${b}`;
          });
          formFields[i]["apps"] = listofnrmlapps;
        } else {
          formFields[i]["apps"] = "notapply";
        }

        if (programmingapps[i]) {
          const listofprogrammingapps = programmingapps[i].map((b) => {
            return `${b}`;
          });
          formFields[i]["programming"] = listofprogrammingapps;
        } else {
          formFields[i]["programming"] = "notapply";
        }

        if (devopsapps[i]) {
          formFields[i]["tools"] = devopsapps[i];
        } else {
          formFields[i]["tools"] = "notapply";
        }
        if (Systemtools[i]) {
          const listofsystemtools = Systemtools[i].map((b) => {
            return `${b}`;
          });
          formFields[i]["systemtools"] = listofsystemtools;
        } else {
          formFields[i]["systemtools"] = "notapply";
        }
      });

      if (normalapps["apps"]) {
        const listofnrmlapps = normalapps["apps"].map((b) => {
          return `${b}`;
        });
        state1["apps"] = listofnrmlapps;
      } else {
        state1["apps"] = "notapply";
      }

      if (programmingapps["programming"]) {
        const listofprogrammingapps = programmingapps["programming"].map((b) => {
          return `${b}`;
        });
        state1["programming"] = listofprogrammingapps;
      } else {
        state1["programming"] = "notapply";
      }

      if (devopsapps["tools"]) {
        state1["tools"] = devopsapps["tools"];
      } else {
        state1["tools"] = "notapply";
      }
      if (Systemtools["system_tools"]) {
        const listofsystemtools = Systemtools["system_tools"].map((b) => {
          return `${b}`;
        });
        state1["systemtools"] = listofsystemtools;
      } else {
        state1["systemtools"] = "notapply";
      }

      // console.log("*************************************");

      const count_startDate = state.start_date_time.split("T")[0];
      const count_endDate = state.end_date_time.split("T")[0];
      const CountstartTime = state.start_date_time.split("T")[1];
      const CountstopTime = state.end_date_time.split("T")[1];
      const start = state.start_date_time;
      const date1 = new Date(start);
      const end = state.end_date_time;
      const date2 = new Date(end);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      const hoursDifference = timeDiff / (1000 * 60 * 60); // Time difference in hours
      const actual_hrs = state.actualhours;
      var chk_actual_hrs = false;

      // console.log("actual ---> hours", actual_hrs)

      // console.log("srtdate", state.start_date_time.split("T")[0]);
      // console.log("end date", state.end_date_time.split("T")[0]);
      // console.log("CountstartTime", CountstartTime);
      // console.log("CountstopTime", CountstopTime);
      // console.log("actual hours date", state.actualhours);
      // console.log("hoursDifference ---- total hours", hoursDifference);

      if (count_startDate > count_endDate) {
        // console.log("step-5")
        timecount_enddate = timecount_enddate + 1;
        // if (CountstopTime >= CountstartTime) {

        // }
        // if (hoursDifference < parseFloat(actual_hrs)) {
        //   console.log("step-2")
        //   timecount = timecount + 1;
        //   chk_actual_hrs = true;
        // }
      }

      if (actual_hrs.trim() === '' || parseInt(actual_hrs) <= 0) {
        timecount = timecount + 1;
        chk_actual_hrs = true;
      }

      if (count_startDate == count_endDate) {
        if (CountstopTime <= CountstartTime) {
          // console.log("step-1")
          timecount_enddatetime = timecount_enddatetime + 1;
        }
        if (hoursDifference < parseFloat(actual_hrs)) {
          // console.log("step-2")
          timecount = timecount + 1;
          chk_actual_hrs = true;
        }
      }
      // console.log("lab_type-->", state.labtype);
      if (timecount > 0) {
        if (chk_actual_hrs) {
          // console.log("step-3")
          sethourerroropen(true);
        } else {
          setscheduleerroropen(true);
        }
      } else if (timecount_enddatetime > 0) {
        setscheduleerroropen2(true);
      } else if (timecount_enddate > 0) {
        setscheduleerroropen1(true);
      }
      else if (state.labtype === "hypervisedvm") {
        setLoading(true);
        state["customdata"] = formFields;
        state["start_date"] = state.start_date_time.split("T")[0];
        state["end_date"] = state.end_date_time.split("T")[0];
        state["start_time"] = state.start_date_time.split("T")[1];
        state["stop_time"] = state.end_date_time.split("T")[1];
        var value = JSON.stringify(state);
        fetch(`${process.env.REACT_APP_API_URL}/api/hypervizedvmlabestimation/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: value,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              setEstimationcount(data);
              setDialogOpen(true);
              setLoading(false);
            } else {
              setState({ errorMessage: data });
              setLoading(false);
              setDialogOpen(false);
            }
          })
          .catch((error) => {
            window.location.reload();
          });
        // } else if (state.labtype === "hypervisedvm_preconfigapps") {
        //   setLoading(true);
        //   state["customdata"] = formFields;
        //   state["start_date"] = state.start_date_time.split("T")[0];
        //   state["end_date"] = state.end_date_time.split("T")[0];
        //   state["start_time"] = state.start_date_time.split("T")[1];
        //   state["stop_time"] = state.end_date_time.split("T")[1];
        //   var value = JSON.stringify(state);
        //   fetch(`${process.env.REACT_APP_API_URL}/api/hvmpclabestimation/`, {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: "Bearer " + localStorage.getItem("token"),
        //     },
        //     body: value,
        //   })
        //     .then((response) => response.json())
        //     .then((data) => {
        //       if (data) {
        //         setEstimationcount(data);
        //         setLoading(false);
        //         setDialogOpen(true);
        //       } else {
        //         setState({ errorMessage: data });
        //         setLoading(false);
        //         setDialogOpen(false);
        //       }
        //     })
        //     .catch((error) => {
        //       window.location.reload();
        //     });
        // }
      }  else if (state.labtype === "sharedvm") {
        setLoading(true);
        state["customdata"] = state1;
        state["start_date"] = state.start_date_time.split("T")[0];
        state["end_date"] = state.end_date_time.split("T")[0];
        state["start_time"] = state.start_date_time.split("T")[1];
        state["stop_time"] = state.end_date_time.split("T")[1];
        var value = JSON.stringify(state);
        fetch(`${process.env.REACT_APP_API_URL}/api/labestimation/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: value,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              setEstimationcount(data);
              setLoading(false);
              setDialogOpen(true);
            } else {
              setState1({ errorMessage: data });
              setLoading(false);
              setDialogOpen(false);
            }
          })
          .catch((error) => {
            window.location.reload();
          });
      } else {
        setLoading(true);
        state["customdata"] = formFields;
        state["start_date"] = state.start_date_time.split("T")[0];
        state["end_date"] = state.end_date_time.split("T")[0];
        state["start_time"] = state.start_date_time.split("T")[1];
        state["stop_time"] = state.end_date_time.split("T")[1];
        var value = JSON.stringify(state);
        // console.log("Step-2", value);
        fetch(`${process.env.REACT_APP_API_URL}/api/labestimation/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: value,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              // console.log("windowschecking",data)
              setEstimationcount(data);
              setLoading(false);
              setDialogOpen(true);
            } else {
              // console.log("windowschecking-1", data)
              setState({ errorMessage: data });
              setLoading(false);
              setDialogOpen(false);
            }
          })
          .catch((error) => {
            window.location.reload();
          });
      }
    }
  };

  const handleCacheClear = (e) => {
    e.preventDefault();
    // setEstimationcount({
    //   application: "",
    //   no_of_trainee: "",
    //   actual_hours: "",
    //   overall_app_price: "",
    //   overall_type_price: "",
    //   overall_storage_price: "",
    //   total_price: 0,
    //   details: [],
    // });
    // setState({
    //   reportname: "",
    //   labtype: "applications",
    //   nooftrainee: "",
    //   actualhours: "",
    //   application: "",
    //   machinetype: "linux",
    //   ostype: "linux",
    //   instance_type: "",
    //   instance_storage: "",
    //   customdata: "",
    //   start_date_time: "",
    //   end_date_time: "",
    // });
    // setState({});
    window.location.reload();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <LoadingOverlay loading={loading}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">FIELD REQUIRED</DialogTitle>
          <DialogContent dividers>
            <Alert severity="error">
              <Typography color="textSecondary" gutterBottom variant="h6">
                Please enter the Lab Name
              </Typography>
            </Alert>
          </DialogContent>

          {/* <DialogContent>
          <DialogContentText>
            Please enter the Lab Name
          </DialogContentText>
          <br />
          <br />
        </DialogContent> */}
          <DialogActions>
            <Tooltip title="Close dialog">
              <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <Dialog
          open={dialogOpen}
          // onClose={handleDialogClose}
          onClose={(event, reason) => {
            // Only allow closing through the cancel button
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return;
            }
            handleDialogClose();
          }}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
        >
          <DialogTitle id="form-dialog-title">Lab Estimation</DialogTitle>
          <DialogContent>
            <p>Lab Estimated Credit is : {`${estimationcount.total_price}`}</p>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              {state.labtype === "applications" ||
                // state.labtype === "hypervisedvm_preconfigapps" ||
                state.labtype === "custom" ||
                state.labtype === "hypervisedvm" ||
                state.labtype === "wise" ? (
                <Grid item xs={6}>
                  <PDF
                    estimationcount={estimationcount}
                    state={state}
                    details={estimationcount.details}
                  />
                </Grid>
              ) : (
                <Grid item xs={6}>
                  <PDF2
                    estimationcount={estimationcount}
                    state={state}
                    details={estimationcount.details}
                  />
                </Grid>
              )}
              <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Tooltip title="Close dialog">
                  <Button onClick={handleDialogClose} variant="contained" color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                    Ok
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Helmet>
          <title>LabAsService</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: "background.default",
            minHeight: "100%",
            py: 3,
          }}
        >
          <Container maxWidth={false}>
            <ScheduleError
              validerroropen={scheduleerroropen}
              setvaliderroropen={setscheduleerroropen}
            />
            <ScheduleError_enddate
              validerroropen={scheduleerroropen1}
              setvaliderroropen={setscheduleerroropen1}
            />
            <ScheduleError_enddatetime
              validerroropen={scheduleerroropen2}
              setvaliderroropen={setscheduleerroropen2}
            />
            <HourError
              validhourerroropen={hourerroropen}
              setvalidhourerroropen={sethourerroropen}
            />
            <Card>

              <CardHeader
                title="Lab Estimation"
                titleTypographyProps={{ fontWeight: 'bold' }}
                action={
                  <Grid container spacing={1}>
                    <Grid item xs={25}>
                      <Card
                        sx={{ 
                          height: "100%", 
                          width: "100%", 
                          padding: "4px", 
                          backgroundColor: 'success.light', 
                          background: 'linear-gradient(135deg, #4caf50 0%, #45a049 100%)',
                          borderRadius: '50px'
                        }}
                        align="center"
                      >
                        <Typography
                          variant="body1"
                          sx={{ 
                            color: 'white',
                            fontWeight: 700,
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)'
                          }}
                        >
                          {`Credits: ${estimationcount.total_price}`}
                        </Typography>
                      </Card>
                    </Grid>
                  </Grid>
                }
              />
              <Divider />
              <CardContent>
                <Grid container justify="center" spacing={3}>
                  <Grid container spacing={3} item justify="flex-end" xs={12}>
                    <Grid item xs={3}>
                      <InputLabel>
                        Lab Name
                        <small style={{ paddingLeft: "10px" }}>required</small>
                        <small style={{ color: "red" }}>*</small>
                      </InputLabel>
                      <TextField
                        fullWidth
                        name="reportname"
                        id="reportname"
                        onChange={handleChange}
                        value={state.reportname}
                        required
                        size="small"
                        autoComplete="off"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <InputLabel>
                        Lab Type
                        <small style={{ paddingLeft: "10px" }}>required</small>
                        <small style={{ color: "red" }}>*</small>
                      </InputLabel>
                      <TextField
                        fullWidth
                        name="labtype"
                        id="labtype"
                        onChange={handleChange}
                        value={state.labtype}
                        required
                        select
                        SelectProps={{ native: true }}
                        autoComplete="off"
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      >
                        <option key="applications" value="applications">
                          Preconfigured
                        </option>
                        <option key="custom" value="custom">
                          Custom
                        </option>
                        <option key="hypervisedvm" value="hypervisedvm">
                          Hypervised
                        </option>
                        <option key="wise" value="wise">
                          Wise
                        </option>
                        <option key="sharedvm" value="sharedvm">
                          Shared
                        </option>
                      </TextField>
                    </Grid>

                    {state.labtype === "sharedvm" ? (
                      <Grid item xs={3}>
                        <InputLabel>
                          Number of Trainee
                          <small style={{ paddingLeft: "10px" }}>required</small>
                          <small style={{ color: "red" }}>*</small>
                        </InputLabel>
                        <TextField
                          name="nooftrainee"
                          id="nooftrainee"
                          value={state.nooftrainee}
                          helperText="Enter the minimum number of trainees min: 4"
                          onChange={handleChange}
                          required
                          autoComplete="name"
                          type="number"
                          InputProps={{
                            inputProps: {
                              min: 4,
                              height: "40px",
                            },
                          }}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={3}>
                        <InputLabel>
                          Number of Trainee
                          <small style={{ paddingLeft: "10px" }}>required</small>
                          <small style={{ color: "red" }}>*</small>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name="nooftrainee"
                          id="nooftrainee"
                          value={state.nooftrainee}
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            const charCode = e.which ? e.which : e.keyCode;
                            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                              e.preventDefault();
                            }
                          }}
                          required
                          autoComplete="nooftrainee"
                          type="number"
                          inputProps={{ min: "0", max: "50", step: "1" }}
                          InputProps={{
                            style: {
                              height: "40px",
                            },
                          }}
                        />
                      </Grid>
                    )}

                    {state.labtype === "applications" ? (
                      <Grid item xs={3}>
                        <InputLabel>
                          Applications
                          <small style={{ paddingLeft: "10px" }}>required</small>
                          <small style={{ color: "red" }}>*</small>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name="application"
                          id="application"
                          onChange={handleChange}
                          value={state.application}
                          required
                          select
                          SelectProps={{ native: true }}
                          autoComplete="shipping address-line1"
                          InputProps={{
                            style: {
                              height: "40px",
                            },
                          }}
                        >
                          {" "}
                          <option key="" value=""></option>
                          {templateapplication.map((templateapplication) => {
                            return (
                              <React.Fragment>
                                <option key={templateapplication} value={templateapplication}>
                                  {templateapplication}
                                </option>
                              </React.Fragment>
                            );
                          })}
                        </TextField>
                      </Grid>
                    ) : state.labtype === "hypervisedvm_preconfigapps" ? (
                      <Grid item xs={3}>
                        <InputLabel>
                          Applications
                          <small style={{ paddingLeft: "10px" }}>required</small>
                          <small style={{ color: "red" }}>*</small>
                        </InputLabel>
                        <TextField
                          fullWidth
                          name="application"
                          id="application"
                          onChange={handleChange}
                          value={state.application}
                          required
                          select
                          SelectProps={{ native: true }}
                          autoComplete="application"
                          InputProps={{
                            style: {
                              height: "40px",
                            },
                          }}
                        >
                          {" "}
                          <option key="" value=""></option>
                          <option key="ansible" value="ansible">
                            Ansible
                          </option>
                          <option key="jenkins" value="jenkins">
                            Jenkins
                          </option>
                          <option key="docker" value="docker">
                            Docker
                          </option>
                          <option key="kubernetes" value="kubernetes">
                            Kubernetes
                          </option>
                          <option key="microservice" value="microservice">
                            Microservice
                          </option>
                          <option key="devops" value="devops">
                            Devops
                          </option>
                          <option key="devsecops" value="devsecops">
                            Devsecops
                          </option>
                          <option key="hadoop" value="hadoop">
                            Hadoop
                          </option>
                          <option key="zabbix" value="zabbix">
                            Zabbix
                          </option>
                          <option key="nagios" value="nagios">
                            Nagios
                          </option>
                          <option key="jfrog" value="jfrog">
                            Jfrog
                          </option>
                          <option key="gitlab" value="gitlab">
                            Gitlab
                          </option>
                          <option key="saltstack" value="saltstack">
                            Saltstack
                          </option>
                          <option key="puppet" value="puppet">
                            Puppet
                          </option>
                          <option key="rundeck" value="rundeck">
                            Rundeck
                          </option>
                          <option key="elk" value="elk">
                            ELK
                          </option>
                          <option key="chef" value="chef">
                            Chef
                          </option>
                        </TextField>
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid item xs={12}></Grid>
                    <Grid item xs={12}>
                      <EstimationSchedule
                        state={state}
                        setState={setState}
                        checkstate={checkstate}
                        setCheckstate={setCheckstate}
                      />
                    </Grid>
                  </Grid>
                  <Divider />
                  {/* 
                {loading && (
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress sx={{
                      height: 20, // Set the height here (in pixels)
                    }} />
                  </Box>
                )} */}
                  <Grid container spacing={3} item justify="flex-end" xs={12}>
                    {state.labtype === "applications" ? (
                      <React.Fragment>
                        {state.application ? (
                          <PreInstalledApplications
                            application={state.application}
                            state={state}
                            setState={setState}
                          />
                        ) : (
                          ""
                        )}
                      </React.Fragment>
                    ) : state.labtype === "hypervisedvm_preconfigapps" ? (
                      <React.Fragment>
                        {state.application ? (
                          <HypervisedPreInstalledApplications
                            application={state.application}
                            state={state}
                            setState={setState}
                          />
                        ) : (
                          ""
                        )}
                      </React.Fragment>
                    ) : state.labtype === "custom" ? (
                      <Grid item xs={12}>
                        <CustomApplications
                          mainstate={state}
                          mainsetState={setState}
                          instancetype={instancetype}
                          setInstancetype={setInstancetype}
                          formFields={formFields}
                          setFormFields={setFormFields}
                          linuxsingleselectedapp={linuxsingleselectedapp}
                          setLinuxsingleselectedapp={setLinuxsingleselectedapp}
                          linuxmultiselectindex={linuxmultiselectindex}
                          setlinuxmultiselectindex={setlinuxmultiselectindex}
                          linuxselectedapps={linuxselectedapps}
                          setLinuxselectedapps={setLinuxselectedapps}
                          windowssingleselectedapp={windowssingleselectedapp}
                          setWindowssingleselectedapp={
                            setWindowssingleselectedapp
                          }
                          windowsmultiselectindex={windowsmultiselectindex}
                          setWindowsmultiselectindex={setWindowsmultiselectindex}
                          windowsselectedapps={windowsselectedapps}
                          setWindowsselectedapps={setWindowsselectedapps}
                          setProgrammingapps={setProgrammingapps}
                          setSystemtools={setSystemtools}
                          setNormalapps={setNormalapps}
                          setDevopsapps={setDevopsapps}
                          setDevopsport={setDevopsport}
                          setNormalport={setNormalport}
                        />
                      </Grid>
                    ) : state.labtype === "sharedvm" ? (
                      <Grid item xs={12}>
                        <SharedvmApplications
                          state1={state1}
                          setState1={setState1}
                          svminstancetype={svminstancetype}
                          setVirtualizationtype={setVirtualizationtype}
                          linuxsingleselectedapp={linuxsingleselectedapp}
                          setLinuxsingleselectedapp={setLinuxsingleselectedapp}
                          linuxmultiselectindex={linuxmultiselectindex}
                          setlinuxmultiselectindex={setlinuxmultiselectindex}
                          linuxselectedapps={linuxselectedapps}
                          setLinuxselectedapps={setLinuxselectedapps}
                          windowssingleselectedapp={windowssingleselectedapp}
                          setWindowssingleselectedapp={
                            setWindowssingleselectedapp
                          }
                          windowsmultiselectindex={windowsmultiselectindex}
                          setWindowsmultiselectindex={setWindowsmultiselectindex}
                          windowsselectedapps={windowsselectedapps}
                          setWindowsselectedapps={setWindowsselectedapps}
                          setProgrammingapps={setProgrammingapps}
                          setSystemtools={setSystemtools}
                          setNormalapps={setNormalapps}
                          setDevopsapps={setDevopsapps}
                          setDevopsport={setDevopsport}
                          setNormalport={setNormalport}
                        />
                      </Grid>
                    ) : state.labtype === "wise" ? (
                      <Grid item xs={12}>
                        <WiseApplications
                          mainstate={state}
                          mainsetState={setState}
                          instancetype={instancetype}
                          setInstancetype={setInstancetype}
                          formFields={formFields}
                          setFormFields={setFormFields}
                          linuxsingleselectedapp={linuxsingleselectedapp}
                          setLinuxsingleselectedapp={setLinuxsingleselectedapp}
                          linuxmultiselectindex={linuxmultiselectindex}
                          setlinuxmultiselectindex={setlinuxmultiselectindex}
                          linuxselectedapps={linuxselectedapps}
                          setLinuxselectedapps={setLinuxselectedapps}
                          windowssingleselectedapp={windowssingleselectedapp}
                          setWindowssingleselectedapp={
                            setWindowssingleselectedapp
                          }
                          windowsmultiselectindex={windowsmultiselectindex}
                          setWindowsmultiselectindex={setWindowsmultiselectindex}
                          windowsselectedapps={windowsselectedapps}
                          setWindowsselectedapps={setWindowsselectedapps}
                          setProgrammingapps={setProgrammingapps}
                          setSystemtools={setSystemtools}
                          setNormalapps={setNormalapps}
                          setDevopsapps={setDevopsapps}
                          setDevopsport={setDevopsport}
                          setNormalport={setNormalport}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={12}>
                        <VirtualizationCustomApplications
                          mainstate={state}
                          mainsetState={setState}
                          virtualizationtype={virtualizationtype}
                          setVirtualizationtype={setVirtualizationtype}
                          formFields={formFields}
                          setFormFields={setFormFields}
                          linuxsingleselectedapp={linuxsingleselectedapp}
                          setLinuxsingleselectedapp={setLinuxsingleselectedapp}
                          linuxmultiselectindex={linuxmultiselectindex}
                          setlinuxmultiselectindex={setlinuxmultiselectindex}
                          linuxselectedapps={linuxselectedapps}
                          setLinuxselectedapps={setLinuxselectedapps}
                          windowssingleselectedapp={windowssingleselectedapp}
                          setWindowssingleselectedapp={
                            setWindowssingleselectedapp
                          }
                          windowsmultiselectindex={windowsmultiselectindex}
                          setWindowsmultiselectindex={setWindowsmultiselectindex}
                          windowsselectedapps={windowsselectedapps}
                          setWindowsselectedapps={setWindowsselectedapps}
                          setProgrammingapps={setProgrammingapps}
                          setSystemtools={setSystemtools}
                          setNormalapps={setNormalapps}
                          setDevopsapps={setDevopsapps}
                          setDevopsport={setDevopsport}
                          setNormalport={setNormalport}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
              <Grid item xs={12}>
                <br />

                <Divider />
                <br />
                <br />
              </Grid>
              <CardContent>
                <CardActions>
                  {/* <div className={classes.btncenter}> */}

                  {/* <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitClick}
              >
                Estimate
              </Button> */}
                  {/* action={ */}
                  <Grid container spacing={4}>
                    {/* <Grid item xs={3.5}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitClick}
                  >
                    Estimate
                  </Button>
                  </Grid> */}
                    {/* <Grid item xs={5}>
                    <Card
                      sx={{ height: "100%", width: "100%", padding: "4px" }}
                      align="center"
                    >
                      <Typography
                        variant="contained"
                        color="Primary"
                        //  align="Left"
                      >
                        {`Credits: ${estimationcount.total_price}`}
                      </Typography>
                    </Card>
                  </Grid> */}
                    <Grid item xs={3.5}>
                      <Tooltip title={estimationcount.total_price > 0 ? "Clear estimation results" : "No estimation to clear"}>
                        <span>
                          <Button
                            startIcon={<ClearIcon />}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleCacheClear}
                            disabled={estimationcount.total_price > 0 ? false : true}
                            sx={{ borderRadius: '50px' }}
                          >
                            Clear
                          </Button>
                        </span>
                      </Tooltip>
                    </Grid>

                    {state.labtype === "applications" ? (
                      <Grid item xs={3.5}>
                        <PDF
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    ) : state.labtype === "hypervisedvm_preconfigapps" ? (
                      <Grid item xs={3.5}>
                        <PDF
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    ) : state.labtype === "custom" ? (
                      <Grid item xs={3.5}>
                        <PDF1
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    ) : state.labtype === "hypervisedvm" ? (
                      <Grid item xs={3.5}>
                        <PDF1
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    ) : state.labtype === "wise" ? (
                      <Grid item xs={3.5}>
                        <PDF1
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={3.5}>
                        <PDF2
                          estimationcount={estimationcount}
                          state={state}
                          details={estimationcount.details}
                        />
                      </Grid>
                    )}
                    <Grid item xs={3.5}>
                      <Tooltip title={!state.reportname || !state.labtype || !state.nooftrainee ||
                        !state.actualhours || !state.start_date_time || !state.end_date_time 
                        ? "Please fill all required fields" : "Calculate lab estimation"}>
                        <span>
                          <Button
                            startIcon={<CalculateIcon />}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleSubmitClick}
                            disabled={!state.reportname || !state.labtype || !state.nooftrainee ||
                              !state.actualhours || !state.start_date_time || !state.end_date_time}
                            sx={{ borderRadius: '50px' }}
                          >
                            Estimate
                          </Button>
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  {/* } */}
                  {/* </div> */}
                </CardActions>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </LoadingOverlay>
    </div >
  );
}
